/**
 * Translations
 */

import { EnvironmentUrls } from 'Roblox';
import UrlConfig from '../../../../../../Roblox.CoreScripts.WebApp/Roblox.CoreScripts.WebApp/js/core/http/interfaces/UrlConfig';

const URL_NOT_FOUND = 'URL_NOT_FOUND';
const domainUrl = EnvironmentUrls.domain ?? URL_NOT_FOUND;

// TODO: Add this URL to be populated in EnvironmentUrls (in `web-platform`).
const translationsApiUrl = `https://translations.${domainUrl}`;

export enum TranslationsError {
  UNKNOWN = 0,
  INVALID_LOCALE = 1,
  CONSUMER_TYPE_NOT_SUPPORTED = 2,
  TRANSLATIONS_DO_NOT_EXIST = 3,
  FEATURE_DISABLED = 4
}

export enum ConsumerType {
  Web = 'Web'
}

/**
 * Request Type: `GET`.
 */
export const GET_LANGUAGE_RESOURCES_CONFIG: UrlConfig = {
  withCredentials: true,
  url: `${translationsApiUrl}/v1/translations/language-resources`,
  timeout: 10000
};

export type GetLanguageResourcesReturnType<K extends ReadonlyArray<string>> = {
  [key in K[number]]: string;
};
